export const blackoutTypes = (state) => state.blackoutTypes
export const campsiteBlackouts = (state) => state.campsiteBlackouts
export const parkingBlackouts = (state) => state.parkingBlackouts
